import { css } from 'styled-components';

const smartButtonStyles = css`
  background: ${props => {
    if (props.success) return props.theme.btnSuccess;
    if (props.danger) return props.theme.btnDanger;
    return props.theme.btnDefault;
  }};
  color: #ffffff;
  margin-left: auto;
  margin-right: auto;
  display: block;
  font-size: 16px;
  font-weight: 700;
  border-radius: 3px;
  overflow: visible;
  padding: 12px;
  -webkit-transition: background-color 0.25s ease-out, color 0.25s ease-out;
  -o-transition: background-color 0.25s ease-out, color 0.25s ease-out;
  transition: background-color 0.25s ease-out, color 0.25s ease-out;
  vertical-align: middle;
  border: 1px solid transparent;
  text-align: center;
  line-height: 1;
  cursor: pointer;
  outline: none;
  -webkit-appearance: none;
  -webkit-transform: scale(1);
  -ms-transform: scale(1);
  transform: scale(1);

  &:disabled {
    background-color: ${props => props.theme.btnInactive};
    cursor: not-allowed;
    &:hover {
      background-color: ${props => props.theme.btnInactive};
    }
  }

  &:hover {
    background: ${props => {
      if (props.success) return props.theme.btnSuccessHover;
      if (props.danger) return props.theme.btnDangerHover;
      return props.theme.btnDefaultHover;
    }};
    color: #ffffff;
  }
`;

export default smartButtonStyles;
